import { render, staticRenderFns } from "./inPurchasingLowPrice.vue?vue&type=template&id=28b14a46&scoped=true"
import script from "./inPurchasingLowPrice.vue?vue&type=script&lang=js"
export * from "./inPurchasingLowPrice.vue?vue&type=script&lang=js"
import style0 from "./inPurchasingLowPrice.vue?vue&type=style&index=0&id=28b14a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b14a46",
  null
  
)

export default component.exports